if (!customElements.get('mobile-menu-search')) {
  customElements.define(
    'mobile-menu-search',
    class MobileMenuSearch extends window.BAO.CustomElement {
      constructor () {
        super()
        this.setupListeners()
      }

      setupListeners () {
        const searchButton = this.querySelector('[data-mobile-menu-search]')
        if (searchButton) {
          searchButton.addEventListener(
            'click',
            this.handleSearchClick.bind(this)
          )
        }
      }

      handleSearchClick (e) {
        e.preventDefault()

        if (window.drawers) {
          window.drawers.activeDrawerKey = ''
        }

        const mobileSearchInput = document.querySelector(
          '[data-search-input-mobile]'
        )

        if (mobileSearchInput) {
          mobileSearchInput.focus()
        }
      }
    }
  )
}
